import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAppAuth } from 'src/context/use-app-auth';
import { useReviewStats } from 'src/api/hooks/use-review-stats';
import ReviewList from './review-list';
import ReviewGrid from './review-grid';
import { useWindowDimensions } from 'src/utils/ui/dimensions';
import { useTranslation } from 'src/text';
import { monthlySummaryId } from 'src/api/collections';

const ReviewStatsList: React.FC = () => {
  const { user, location } = useAppAuth();
  const { isMobile } = useWindowDimensions();
  const { keywordLabels } = useTranslation();

  const { reviewStats } = useReviewStats({
    userId: user?.key,
    locationId: location?.key,
  });

  const summaryStat = reviewStats.find(stat => stat.key === monthlySummaryId);
  const finalReviews = reviewStats.filter(
    stat => stat.key !== monthlySummaryId,
  );

  return (
    <>
      <Box mt={4} sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
        <Typography variant="h3">{keywordLabels.reviewStats}</Typography>
        {keywordLabels.reviewStatsInfo && (
          <Tooltip
            title={keywordLabels.reviewStatsInfo}
            placement="right"
            arrow>
            <IconButton size="small" aria-label="About review statistics">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Box mt={2}>
        <Typography mt={2} mb={2} variant="body1">
          {summaryStat?.summary ?? ''}
        </Typography>

        {isMobile ? (
          <ReviewList data={finalReviews} />
        ) : (
          <ReviewGrid data={finalReviews} />
        )}
      </Box>
    </>
  );
};

export { ReviewStatsList };
